import { all } from "redux-saga/effects";
import { keHoachThucTapSaga } from "./keHoachThucTapSaga";
import { keHoachThucTapPhamViSaga } from "./keHoachThucTapPhamViSaga";
import { xetThucTapSaga } from "./xetThucTapSaga";
import { keHoachThucTapDoanhNghiepSaga } from "./keHoachThucTapDoanhNghiepSaga";
import { danhSachDuDieuKienThucTapSaga } from "./danhSachDuDieuKienThucTapSaga";
import { sinhVienDangKyThucTapSaga } from "./sinhVienDangKyThucTapSaga";
import { danhSachKhongDuDieuKienThucTapSaga } from "./danhSachKhongDuDieuKienThucTapSaga";
import { keHoachThucTapPhamViSinhVienSaga } from "./keHoachThucTapPhamViSinhVienSaga";

export default function* xetThucTapSagaWrapper() {
    yield all([
        keHoachThucTapSaga(),
        keHoachThucTapPhamViSaga(),
        keHoachThucTapPhamViSinhVienSaga(),
        xetThucTapSaga(),
        keHoachThucTapDoanhNghiepSaga(),
        danhSachDuDieuKienThucTapSaga(),
        danhSachKhongDuDieuKienThucTapSaga(),
        sinhVienDangKyThucTapSaga()
    ]);
    }